<template lang="pug">
  transition(name="slide")
    #sentences.has-position-relative.p-2.has-text-left.w-100(v-if="currentWord.lemma && (sentences[currentWord.lemma] || sentences[currentWord.lemma+'|'+currentWord.pos])")
      .actions
        <!--span Sentences-->
        button.button.is-outlined.ml-auto.is-small(
        @click="openYoutubeModal(currentWord)"
        :title="(!user.id) ? 'Please log in to add videos' : ''"
        )
          //:disabled="!user.id"
          b-icon(icon="video-call" custom-size="mdi-18px")

      div(v-for="(word, idx) in words" :key="idx" v-if="sentences[word]")
        h4.is-size-5.mb-2.mt-1 {{word}}
        .sentence.w-100.mb-1.is-flex(
          v-for="sentence in sentences[word]"
        )
          b-tooltip.mr-2(
            :label='`${sentence.votes_nb || 0} ${sentence.votes_nb > 1 ? "people" : "person"} upvoted`'
            type='is-light'
            :animated='true'
            position='is-top'
            )
            span.has-text-grey-light.is-size-6.has-flex-center-items.is-inline-flex
              i.mdi.mdi-arrow-drop-up.is-size-6.sentence--votes-nb
              | {{ sentence.votes_nb }}
          span.anim-slide-hover.sentence--actions.mr-2.is-inline-flex.mt-1
            button.button.is-small.mt--5px(
            v-if="sentence && user.id && user.id != sentence.user_id"
            @click="votes[sentence.id] ? cancelVote(votes[sentence.id]) : upvote(sentence)"
            :disabled="voting"
            :class="{'is-success': votes[sentence.id], 'is-loading': voting}"
            ) +1
          span.is-clickable(@click="launchVideo(sentence)")
            span(v-if="sentence.category == 'music'")
              | 🎵
              |
            span(v-html="$options.filters.bold(sentence.content, sentence.for_word)")

          button.button.is-outlined.is-small.ml-auto.mr-1(
            v-if="sentence.user_id == user.id"
            @click="openEditYoutubeModal(sentence, currentWord.lemma, currentWord.pos)"
            )
            //:disabled="!user.id"
            //:title="(!user.id) ? 'Please log in to add videos' : ''"
            b-icon(icon="edit" custom-size="mdi-18px")
          button.button.is-white.mr-0.p-0.button-video.is-small(
          :class="{'ml-auto': sentence.user_id != user.id}"
            @click="launchVideo(sentence)"
            )
            <!--img(width="48" height="34" src="/static/youtube-play-active.png")-->
            img.youtube-thumbnail(:src="`https://img.youtube.com/vi/${sentence.youtube_uid}/mqdefault.jpg`")
            <!--b-icon(icon="videocam" custom-size="mdi-18px")-->

</template>

<script>
  import { nodeApi } from "@/config";
  import _ from "lodash";
  import {mapGetters} from 'vuex'
  import youtubeModal from '@/components/YoutubeModal';

  export default {
    name: "Sentences",
    components: {
    },
    props: ['currentWord'],
    computed: {
      ...mapGetters(['sentences', 'user', 'votes']),
      words() {
        return _.uniq([this.currentWord.lemma, this.currentWord.lemma+'|'+this.currentWord.pos].concat(_.keys(this.currentWord.inf)))
      }
    },
    // filters: {
    //   bold(words, query) {
    //     return words.replace(query, '<b>' + query + '</b>')
    //   }
    // },
    data() {
      return {
        voting: false
      };
    },
    mounted () {
    },
    created() {
    },
    methods: {
      openYoutubeModal({lemma, pos}) {
        this.$modal.open({
          parent: this,
          width: 1440,
          props: {
            lemma,
            pos
          },
          component: youtubeModal,
          hasModalCard: false
        })
      },
      openEditYoutubeModal(sentence, lemma, pos) {
        this.$modal.open({
          parent: this,
          width: 1440,
          props: {
            lemma,
            pos,
            model: sentence
          },
          component: youtubeModal,
          hasModalCard: false
        })
      },
      launchVideo(sentence) {
        console.log({sentence});
        this.$store.commit('currentSentence', sentence);
        this.$store.commit('incSentencePlayerRev');
      },
      upvote(sentence) {
        this.voting = true
        this.$store.dispatch('saveVote', sentence).then(res => {
          this.voting = false
        }, err => {
          this.voting = false
        })
      },
      cancelVote(vote) {
        this.$store.dispatch('deleteVote', vote)
      },
    }
  };
</script>

<style lang="scss" scoped>
  @import "colors";

  .slide-leave-active {
    transition-duration: 0.2s;
  }

  .slide-enter-active {
    transition-duration: 0.2s;
  }

  .actions {
    position: absolute;
    top: 0;
    right: 10px;
  }
  .sentence--actions {
    align-items: center;
  }

  .button-video {
    img {
      width: 27px;
      height: 27px;
    }
  }

  .youtube-thumbnail {
    width: 110px !important;
    height: auto !important;
  }

  .sentence {
    font-size: 1.4rem;
    letter-spacing: 1px;
    min-height: 70px;
    line-height: 70px;
  }

  @media screen and (max-width: 425px) {
    body {
      .sentence {
        font-size: 0.9rem;
        letter-spacing: inherit;
        line-height: 1rem;
      }
      .button-video {
        padding: 0 !important;
        margin-right: 0 !important;
        transform: scale(1.2);
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/Sentences.vue